interface TodayMarkerProps {
  show: boolean;
  left: number;
  height: number;
}

const TodayMarker: React.FC<TodayMarkerProps> = ({ show, left, height }) => {
  if (!show) return null;

  return (
    <div>
      <div
        className="absolute top-0 min-h-full border-l-2 border-blue-500 z-[1]"
        style={{
          left: `${left}px`,
          height: `${height}px`,
        }}
      />
      <div
        className="absolute z-[1]"
        style={{
          top: "0px",
          left: `${left - 4.75}px`,
          width: 0,
          height: 0,
          borderLeft: "6px solid transparent",
          borderRight: "6px solid transparent",
          borderTop: "10px solid #3B82F6",
        }}
      />
    </div>
  );
};

export default TodayMarker;
